import { ThreadComm } from "threadcomm";
import { ZeneithDBCore } from "./ZeneithDBCore.js";
export function RegisterZeneithTasks() {
    ThreadComm.registerTasks("zdb-close-database", async (dbId, onDone) => {
        const db = ZeneithDBCore.loadedDatabases[dbId];
        if (!db)
            return;
        await db.waitTillTranscationDone();
        db.close();
        if (onDone)
            onDone();
    }, "deferred");
    ThreadComm.registerTasks("zdb-open-database", async (dbId, onDone) => {
        const db = ZeneithDBCore.loadedDatabases[dbId];
        if (!db)
            return;
        await db.waitTillTranscationDone();
        db.open();
        if (onDone)
            onDone();
    }, "deferred");
}
